import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'

export const apiFetchLanguages = async (): Promise<any[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Language/FetchLanguages`
    `${apiSuffixUrl}/api/Language/FetchLanguages`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}
